var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1447 3.81608C16.3051 3.65564 16.3771 3.42377 16.3122 3.20635C15.758 1.34928 14.0401 0 12 0C9.51 0 7.5 2.01 7.5 4.5V11.625C7.5 11.9088 7.83922 12.0552 8.04571 11.8605L8.7645 11.1828C8.9148 11.0411 9 10.8437 9 10.6371V4.5C9 2.85 10.35 1.5 12 1.5C13.65 1.5 15 2.85 15 4.5C15 4.67004 15.2056 4.7552 15.3258 4.63496L16.1447 3.81608ZM16.5 6.28922L15 7.78922V12C15 13.65 13.65 15 12 15C10.8653 15 9.8725 14.3616 9.36304 13.4262L8.26884 14.5204C9.07676 15.7159 10.4447 16.5 12 16.5C14.49 16.5 16.5 14.49 16.5 12V6.28922ZM5.91515 14.0456C6.12014 13.8406 6.19217 13.5407 6.13178 13.2571C6.04543 12.8518 6 12.4312 6 12C6 11.58 5.67 11.25 5.25 11.25C4.83 11.25 4.5 11.58 4.5 12C4.5 12.045 4.5 12.105 4.515 12.15C4.5237 12.7027 4.59271 13.241 4.71579 13.7584C4.84602 14.3059 5.51719 14.4436 5.91515 14.0456ZM6.12908 16.6601L7.19467 15.5945C8.2888 17.0552 10.0336 18 12 18C15.315 18 18 15.315 18 12C18 11.58 18.33 11.25 18.75 11.25C19.17 11.25 19.5 11.58 19.5 12C19.5 12.045 19.5 12.105 19.485 12.15C19.425 15.96 16.5 19.08 12.75 19.455V22.5H15.75C16.17 22.5 16.5 22.83 16.5 23.25C16.5 23.67 16.17 24 15.75 24H8.25C7.83 24 7.5 23.67 7.5 23.25C7.5 22.83 7.83 22.5 8.25 22.5H11.25V19.455C9.17538 19.2475 7.35327 18.1999 6.12908 16.6601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 19.875L20.625 2.625",
    stroke: "#FF0055",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMuted);
export default __webpack_public_path__ + "static/media/audio-muted.5cf005f3d956b6c9268b24bfc2881139.svg";
export { ForwardRef as ReactComponent };